"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueTemplatesApi = void 0;
var _endpointHelpers = require("../util/endpointHelpers");
var _IssueTemplateMigration = require("../util/migrationHelpers/IssueTemplateMigration");
var _queryClientUtils = require("../util/queryClientUtils");
const IssueTemplatesApi = exports.IssueTemplatesApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    getAll: () => api.getAll("issue-templates?limit=9999").then((0, _endpointHelpers.mapResults)(_IssueTemplateMigration.IssueTemplateMigration.deserialize)),
    create: template => api.create("issue-templates", _IssueTemplateMigration.IssueTemplateMigration.serialize(template)).then(rawIssueTemplate => {
      return _IssueTemplateMigration.IssueTemplateMigration.deserialize(rawIssueTemplate);
    }),
    update: (templateId, templateChange) => api.update("issue-templates/".concat(templateId), _IssueTemplateMigration.IssueTemplateMigration.serialize(templateChange)).then(rawIssueTemplate => {
      return _IssueTemplateMigration.IssueTemplateMigration.deserialize(rawIssueTemplate);
    }),
    delete: templateId => api.delete("issue-templates/".concat(templateId))
  };
}, {
  invalidateByQueryKeys: () => _queryClientUtils.INVALIDATE_ALL_QUERIES
});
//# sourceMappingURL=IssueTemplatesApi.js.map